import PageLoader from '@src/components/Loader/PageLoader'
import type { ReactNode } from 'react'
import { Suspense } from 'react'

interface Props {
  children: ReactNode
}

const GlobalLoaderProvider = ({ children }: Props) => {
  return <Suspense fallback={<PageLoader />}>{children}</Suspense>
}

export default GlobalLoaderProvider
